export default __webpack_public_path__ + "static/media/64952590-2243-460C-B040-91C4AFD70C88 - 837_SWASTIKA BISHNOI.ec9c9167.jpeg";